<template>
  <div v-if="
  this.enableAccessAuthView(data.tagd, this.getUser.pref.select.cauth) === true ||
  this.enableAccessAuthView(data.tagd, this.getUser.pref.select.fauth) === true
  ">
    <div v-if="btnSpinGetTree === false">
      <v-btn
      :color="ui.btnColor"
      icon v-if="data.size == 'icon'"
      @click="getAssetTree()"
      flat dark>
        <v-icon :color="ui.btnColor"> account_tree </v-icon>
      </v-btn>
      <v-btn
      :color="ui.btnColor"
      v-if="data.size == 'flat' || data.size == undefined"
      @click="getAssetTree()"
      flat dark>
        <v-icon left :color="ui.btnColor"> account_tree </v-icon>
          Tree
      </v-btn>
    </div>
    <div v-else>
      <BtnSpin dark v-if="data.size == 'icon'" :btnSpec="btnInfo1"/>
      <BtnSpin dark v-if="data.size == 'flat'" :btnSpec="btnInfo2"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import routerFunctions from "@/data/functions/mixins/routerFunctions.js";
import registerFunctions from "@/data/functions/mixins/registerFunctions.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
export default {
  // eslint-disable-next-line
  mixins: [
    apptheme,
    getList,
    storeFunctions,
    routerFunctions,
    registerFunctions,
    dataSources,
    accessFunctions
  ],
  methods: {
    getAssetTree() {
      // console.log("");
      // console.log("GET TREE");
      this.btnSpinGetTree = true;
      // page title
      let title = "Asset Tree";
      this.$store.dispatch("changePageTitle", title);
      // GO to Embedded Register
      if (
        this.data.did !== null &&
        this.data.did !== undefined &&
        this.data.tag === "A1.R" &&
        this.data.type === null
      ) {
        // console.log("EMBEDDED TREE");
        let did = this.data.did;
        this.getTreeAsset(did);
      }

      // GO to Child Asset Register
      if (
        this.data.item === null &&
        this.data.type === null &&
        this.data.tag === "A1.C" &&
        this.getDetailLink !== null
      ) {
        // console.log("GO CHILD");
        let info = {
          did: "",
          id: "",
          idg: "",
          tag: "A1",
          title: ""
        };
        info.did = this.getDetailBasic.did;
        info.id = this.getDetailBasic.id;
        info.idg = this.getDetailBasic.idg;
        info.title = this.getDetailBasic.title;
        this.$store.dispatch("changeTreeParentInfo", info);
        let did = this.data.did;
        this.getTreeAsset(did);
      }

      // GO to Master Asset Register
      if (
        this.data.item === null &&
        this.data.type === null &&
        this.data.tag === "A1.M" &&
        this.getDetailLink !== null
      ) {
        console.log("GO MASTER");
        let info = {
          did: "",
          id: "",
          idg: "",
          tag: "A1",
          title: ""
        };
        info.did = this.getDetailLink.adid;
        info.id = this.getDetailLink.aid;
        info.idg = this.getDetailLink.aidg;
        info.idg = this.getDetailLink.aidg;
        info.title = this.getDetailLink.atitle;
        this.$store.dispatch("changeTreeParentInfo", info);
        let did = this.data.did;
        this.getTreeAsset(did);
      }
      // GO to Master Asset Register
      if (
        this.data.item === null &&
        this.data.type === null &&
        this.data.tag === "A1.P"
      ) {
        console.log("GO PARENT");
        console.log(this.data.did);
        // let info = {
        //   did: "",
        //   id: "",
        //   idg: "",
        //   tag: "A1",
        //   title: ""
        // };
        // info.did = this.getTreeParentInfo.did;
        // info.id = this.getTreeParentInfo.id;
        // info.idg = this.getTreeParentInfo.idg;
        // info.title = this.getTreeParentInfo.title;
        // this.$store.dispatch("changeTreeParentInfo", info);
        let did = this.data.did;
        this.getTreeAsset(did);
      }
    }
  },
  computed: {
    ...mapGetters([
      "getCurrentPage",
      "getDetailBasic",
      "getDetailLink",
      "getUser",
      "getTreeInfo"
    ])
  },
  props: {
    data: {
      type: Object
    }
  },
  components: {
    BtnSpin
  },
  data() {
    return {
      valid: false,
      btnSpinGetTree: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "icon"
      },
      btnInfo2: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "flat"
      }
    };
  }
};
</script>
